<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Add Occupant</h4>
      <button
        class="btn-primary btn btn-sm"
        type="button"
        v-on:click="copyClientDetails"
        :disabled="!client"
      >
        Copy Client Details
      </button>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type"
            :options="types"
            v-model="form.type_id"
            label="Occupant Type"
            placeholder="Please Select"
            helper="Please select the type of occupant"
          ></selectlist>

          <inputbox
            v-model="form.first_name"
            name="first_name"
            label="First Name"
            helper="Please enter the first name of the occupant"
          ></inputbox>

          <inputbox
            v-model="form.last_name"
            name="last_name"
            label="Last Name"
            helper="Please enter the last name of the occupant"
          ></inputbox>

          <date-of-birth
            v-model="form.date_of_birth"
            name="date_of_birth"
            :unlimited="true"
            helper="Please enter the occupants date of birth"
          ></date-of-birth>

          <inputbox
            v-model="form.occupation"
            name="occupation"
            label="Occupation"
            helper="Please enter the occupants occupation"
          ></inputbox>

          <inputbox
            v-model="form.medical_conditions"
            name="medical_conditions"
            helper="If the occupant has any medical conditions, enter them here"
            label="Medical Conditions"
          ></inputbox>

          <inputbox
            v-model="form.relation_to_client"
            name="relation_to_client"
            helper="What relation is the occupant to the client?"
            label="Relation to Client"
          ></inputbox>

          <inputbox
            v-model="form.national_insurance"
            name="national_insurance_number"
            helper="Please enter the occupants national insurance number"
            label="National Insurance Number"
          ></inputbox>

          <selectlist
            :options="positions"
            v-model="form.position_id"
            label="Seat/Position"
            placeholder="Please Select"
            name="position"
            helper="Please choose the position where the occupant was in the vehicle"
          ></selectlist>

          <toggleswitch
            :labels="true"
            name="requires_glasses"
            label="Requires Glasses?"
            helper="Does the occupant require glasses?"
            v-model="form.requires_glasses"
          ></toggleswitch>

          <toggleswitch
            :labels="true"
            name="wearing_seatbelt"
            label="Wearing Seatbelt?"
            helper="Was the occupant wearing a seatbelt?"
            v-model="form.wearing_seatbelt"
          ></toggleswitch>

          <fieldset>
            <legend>
              Contact Details
              <small class="text-muted"
                >- Enter the occupants contact details here</small
              >
            </legend>

            <inputbox
              v-model="form.telephone"
              name="telephone"
              label="Telephone"
              helper="Please enter a contact telephone number for the occupant"
            ></inputbox>

            <inputbox
              v-model="form.email_address"
              name="email"
              label="Email Address"
              type="email"
              helper="Please enter the email address for the occupant"
            ></inputbox>
          </fieldset>
          <fieldset>
            <legend>
              Address Details
              <small class="text-muted"
                >- Enter the occupants address details here</small
              >
            </legend>
            <address-lookup
              name="addresses"
              :address="address"
              v-on:address="setAddress"
            ></address-lookup>
          </fieldset>
          <fieldset>
            <legend>
              Injury Details
              <small class="text-muted"
                >- Enter the occupants injury details here</small
              >
            </legend>

            <input-block
              v-model="form.injury_details"
              name="injury_details"
              label="Injury Details"
              helper="Please enter a description of the occupant's injury"
            ></input-block>

            <toggleswitch
              :labels="true"
              name="has_representation"
              label="Has Representation?"
              helper="Does the occupant have representation already?"
              v-model="form.has_representation"
            ></toggleswitch>

            <div v-if="form.has_representation">
              <inputbox
                v-model="form.representation_company_name"
                name="representation_company_name"
                label="Company Name"
                helper="Please enter the name of the company representing the occupant"
              ></inputbox>

              <inputbox
                v-model="form.representation_reference"
                name="representation_reference"
                label="Reference"
                helper="Please enter the reference for the occupants injury"
              ></inputbox>

              <inputbox
                v-model="form.representation_email"
                name="representation_email"
                label="Email"
                helper="Please enter an email address for the company representing the occupant"
              ></inputbox>

              <inputbox
                v-model="form.representation_telephone"
                name="representation_telephone"
                label="Telephone"
                helper="Please enter a telephone number for the company representing the occupant"
              ></inputbox>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" v-on:clicked="addOccupant"
        >Add New Occupant</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    types: {
      type: Array,
      required: true
    },

    positions: {
      type: Array,
      required: true
    },

    client: {
      type: Object
    }
  },

  data() {
    return {
      form: new window.Form({
        type_id: null,
        first_name: null,
        last_name: null,
        date_of_birth: null,
        occupation: null,
        medical_conditions: null,
        relation_to_client: null,
        national_insurance: null,
        position_id: null,
        requires_glasses: false,
        wearing_seatbelt: true,
        telephone: null,
        email_address: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        injury_details: null,
        has_representation: false,
        representation_company_name: null,
        representation_reference: null,
        representation_email: null,
        representation_telephone: null
      })
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    copyClientDetails() {
      if (this.client) {
        this.form.title_id = this.client.title_id;
        this.form.first_name = this.client.first_name;
        this.form.last_name = this.client.last_name;
        this.form.date_of_birth = this.client.date_of_birth
          ? this.client.date_of_birth
          : null;
        this.form.occupation = this.client.occupation;
        this.form.national_insurance = this.client.national_insurance;
        if (this.client.home_telephone) {
          this.form.telephone = this.client.home_telephone;
        } else if (this.client.work_telephone) {
          this.form.telephone = this.client.work_telephone;
        } else if (this.client.mobile_telephone) {
          this.form.telephone = this.client.mobile_telephone;
        }
        this.form.email_address = this.client.email_address;

        this.setAddress(this.client);

        window.toastify.success(
          'Complete',
          "We've copied those details for you."
        );
      }
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    closeModal() {
      this.$emit('close');
    },

    addOccupant() {
      this.form
        .post('/incidents/' + this.incident + '/occupants')
        .then(response => {
          this.$emit('added', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error creating the occupant.'
          );
        });
    }
  }
};
</script>
